export { default } from '@/features/openTabs/pages/PaymentPage'
